import { AxiosPromise } from 'axios';

import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';

type getDashboardHtttpResponseBody = any;

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
const axiosAws: AxiosVue = new AxiosVue(ServicioProxy.MetabaseAws);

const makeHttpRequest = (
  body: any,
  path: string
): AxiosPromise<getDashboardHtttpResponseBody> => {
  return axiosAws.http.post(`Metabase/PostgenericA/comandos_sms/` + path, body);
};

export const fetchSMS = (body: any, path: string) =>
  makeHttpRequest(body, path);
